var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statistics-block"},[_c('apexchart',{attrs:{"type":"bar","height":"150","options":_vm.chartOptions,"series":_vm.getChartData()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }